import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Only essential preconnects (max 3 — Lighthouse warns about >4)
const preconnects = [{
  href: 'https://fonts.gstatic.com',
  crossorigin: true
}, {
  href: 'https://cdn.magicpatterns.com',
  crossorigin: true
}];
preconnects.forEach(({
  href,
  crossorigin
}) => {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  if (crossorigin) link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
});
// Preload hero image for LCP optimization
const heroPreload = document.createElement('link');
heroPreload.rel = 'preload';
heroPreload.as = 'image';
heroPreload.href = 'https://cdn.magicpatterns.com/uploads/hd63eWM8qU6xYgaTeUajxL/fe82af34c545db296387cb3852bc1586e5585ff9.jpg';
document.head.appendChild(heroPreload);
// Meta robots tag (since robots.txt is not available on this platform)
const robotsMeta = document.createElement('meta');
robotsMeta.name = 'robots';
robotsMeta.content = 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1';
document.head.appendChild(robotsMeta);
// Load Google Fonts non-blocking via media swap trick
const fontLink = document.createElement('link');
fontLink.rel = 'stylesheet';
fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';
fontLink.media = 'print';
fontLink.onload = function () {
  ;
  (this as HTMLLinkElement).media = 'all';
};
document.head.appendChild(fontLink);
// Set page title
document.title = 'ELVORA';
render(<App data-id="element-294" />, document.getElementById('root'));